import { render } from "./CardPromotion.vue?vue&type=template&id=e108d256&scoped=true"
import script from "./CardPromotion.vue?vue&type=script&lang=js"
export * from "./CardPromotion.vue?vue&type=script&lang=js"

import "./CardPromotion.vue?vue&type=style&index=0&id=e108d256&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e108d256"]])

export default __exports__